import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home/Home.vue";
import View from "./views/View/View.vue";
import Item from "./views/View/ItemView.vue";
import Search from "./views/View/SearchView.vue";
import List from "./views/View/ListView.vue";
import Login from "./views/Login/Login";
import ForgetPassword from "./views/Login/ForgetPassword";

import Signup from "./views/Signup/Signup";
import Categories from "./views/AllCategory/Categories";
// import Profile from "./views/profile/Profile.vue";
import MyAccount from "./views/NewProfile/MyAccount.vue";
import store from "./Store/store";

import { TokenService, TokenServiceApp } from "./services/storage.service";

Vue.use(Router);

const router = new Router({
  mode: "history",
  // mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "/profile",
    //   name: "Profile",
    //   component: Profile,
    //   // props: true,
    //   meta: {
    //     public: true,
    //   },
    // },
    {
      path: "/p/profile",
      name: "MyAccount",
      component: MyAccount,
      // props: true,
      meta: {
        public: TokenService.getToken() ? true : false,
        title: 'My Khaanpin - #1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Khaanpiner\'s Page. My Orders, Rewards and Khaanpin Journey. Refer Khaanpin to Your Friends and win amazing offers!'
          },
          {
            property: 'og:description',
            content: 'Khaanpiner\'s Page. My Orders, Rewards and Khaanpin Journey. Refer Khaanpin to Your Friends and win amazing offers!'
          }
        ]
      }
    },
    {
      path: "/p/login",
      name: "Login",
      component: Login,
      // props: true,
      meta: {
        public: TokenService.getToken() ? false : true,
        title: 'Login to Khaanpin - #1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Login to My Khaanpin Account. My Orders, Rewards and Khaanpin Journey. Refer Khaanpin to Your Friends and win amazing offers!'
          },
          {
            property: 'og:description',
            content: 'Login to My Khaanpin Account. My Orders, Rewards and Khaanpin Journey. Refer Khaanpin to Your Friends and win amazing offers!'
          }
        ]
      },
    },
    {
      path: "/p/forget-password",
      name: "ForgetPassword",
      component: ForgetPassword,
      // props: true,
      meta: {
        public: TokenService.getToken() ? false : true,
        title: 'Reset my Khaanpin Account Password - #1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Reset My Khaanpin Profile. My Orders, Rewards and Khaanpin Journey. Refer Khaanpin to Your Friends and win amazing offers!'
          },
          {
            property: 'og:description',
            content: 'Reset My Khaanpin Profile. My Orders, Rewards and Khaanpin Journey. Refer Khaanpin to Your Friends and win amazing offers!'
          }
        ]
      },
    },
    {
      path: "/register",
      name: "Signup",
      component: Signup,
      // props: true,
      meta: {
        public: TokenService.getToken() ? false : true,
        title: 'Create New Khaanpin Account - #1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Create Khaanpin Account. Access My Orders, Rewards and Khaanpin Journey. Refer Khaanpin to Your Friends and win amazing offers!'
          },
          {
            property: 'og:description',
            content: 'Create Khaanpin Account. Access My Orders, Rewards and Khaanpin Journey. Refer Khaanpin to Your Friends and win amazing offers!'
          }
        ]
        
      },
    },
    // {
    //   path: "/:loc?/categories",
    //   name: "Categories",
    //   component: Categories,
    //   props: true,
    //   meta: {
    //     public: true,
    //   },
    // },

    {
      path: "/:loc?/k/:slug?/:cat?",
      name: "Categories",
      component: Categories,
      props: true,
      meta: {
        public: true,
        title: ':slug - #1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      },
    },

    {
      path: "/:loc?",
      name: "Home",
      component: Home,
      props: true,
      meta: {
        public: true,
        title: '#1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      }
    },
    {
      path: "/:loc?/c/:slug?/:id?/:subId?/:catid?/",
      name: "View",
      component: View,
      props: true,
      meta: {
        public: true,
        title: '#1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      },
    },
    {
      path: "/:loc?/i/:slug?",
      name: "Item",
      component: Item,
      props: true,
      meta: {
        public: true,
        title: '#1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      },
    },
    {
      path: "/:loc?/search",
      name: "Search",
      component: Search,
      props: true,
      meta: {
        public: true,
        title: '#1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      },
    },
    {
      path: "/:loc?/l/:slug?",
      name: "List",
      component: List,
      props: true,
      meta: {
        public: true,
        title: '#1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      },
    },
    {
      path: "/p/3",
      name: "Campaign",
      component: () => import("./views/Campaign/Campaign.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/p/order",
      name: "order",
      component: () => import("./views/Checkout/OrderWizard.vue"),
      props: true,
      meta: {
        public: true,
        title: 'One More Step! | #1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      },
    },
    {
      path: "/p/checkout",
      name: "Checkout",
      component: () => import("./views/Checkout/Checkout.vue"),
      props: true,
      meta: {
        public: true,
        title: 'Almost There! #1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      },
    },
    // {
    //   path: "/p/profile",
    //   name: "Profile",
    //   component: () => import("./views/Profile/Profile.vue"),
    //   meta: {
    //     public: true,
    //   },
    // },
    {
      path: "/p/fonepaypayment",
      name: "FonepayPayment",
      component: () => import("./components/Payment/FonepayPayment.vue"),
      props: true,
      meta: {
        public: true,
      },
    },
    {
      path: "/p/fonepaypaymentext",
      name: "FonepayPaymentExt",
      component: () => import("./components/Payment/FonepayPaymentExt.vue"),
      props: true,
      meta: {
        public: true,
      },
    },
    // {
    //   path: "/p/profile",
    //   name: "Profile",
    //   component: () => import("./views/Profile/Profile.vue"),
    //   meta: {
    //     public: true,
    //   },
    // },
    {
      path: "/p/confirmorder",
      name: "ConfirmOrder",
      component: () => import("./views/Checkout/ConfirmOrder.vue"),
      meta: {
        public: true,
         title: 'Thankyou! Order Confirmed! #1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      },
    },
    {
      path: "/p/paymentmethod",
      name: "PaymentMethod",
      component: () => import("./views/Checkout/PaymentMethod.vue"),
      meta: {
        public: true,
        title: 'Thankyou! Order Confirmed! #1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      },
    },
    {
      path: "/p/orderstatus",
      name: "OrderStatus",
      component: () => import("./views/Checkout/OrderStatus.vue"),
      meta: {
        public: true,
        title: 'Thankyou! Order Confirmed! #1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      },
    },
    {
      path: "/p/esewa/success",
      name: "EsewaS",
      component: () => import("./views/SFPages/esewa/SuccessPage.vue"),
      meta: {
        public: true,
        title: 'Thankyou! Payment Successful! #1 Cloud Kitchen in Nepal | Breakfast, Meals, Pizzas, Cakes and Liquor | 24 Hour Delivery, Kathmandu and Pokhara',
        metaTags: [
          {
            name: 'description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          },
          {
            property: 'og:description',
            content: 'Food 🍔, Cakes 🎂 or Liquor 🍺? Now? Yes! 24 Hours 7 Days a week, all day all night delivery from Nepal’s Top Cloud Kitchen. Checkout our Healthy Breakfast, Amazing Pizzas, Delicious Meals and Custom Lunch Boxes. 📦 Fastest Delivery in Kathmandu, Lalitpur, Bhaktapur and Pokhara. Order Online now!'
          }
        ]
      },
    },
    {
      path: "/p/esewa/failure",
      name: "EsewaF",
      component: () => import("./views/SFPages/esewa/FailurePage.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/p/cyber/success",
      name: "CyberS",
      component: () => import("./views/SFPages/nica/SuccessPage.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/p/fonepay/failure",
      name: "FonePaySuccess",
      component: () => import("./views/SFPages/fonepay/FailurePage.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/p/fonepay/success",
      name: "FonePayFailure",
      component: () => import("./views/SFPages/fonepay/SuccessPage.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/p/cyber/failure",
      name: "CyberF",
      component: () => import("./views/SFPages/nica/FailurePage.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/p/imepay/success",
      name: "IMESuccess",
      component: () => import("./views/SFPages/imepay/SuccessPage.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/p/imepay/failure",
      name: "IMEFailure",
      component: () => import("./views/SFPages/imepay/FailurePage.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/p/paynow",
      name: "PayNow",
      component: () => import("./components/Payment/PayNow.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "/p/extpayment",
      name: "ExtPayment",
      component: () => import("./components/Payment/ExternalPayment.vue"),
      meta: {
        public: true,
      },
    },
    {
      path: "*",
      name: "error",
      component: () => import("./views/ErrorPage.vue"),
      meta: {
        public: true,
      },
    },
  ],
});


// router.beforeEach((to, from, next) => {
//   const isPublic = to.matched.some((record) => record.meta.public);
//   const loggedIn = !!TokenService.getToken();
//   const loggedInApp = !!TokenServiceApp.getToken();

//   if (!isPublic && !loggedIn && !loggedInApp) {
//     return next({
//       path: "/p/login",
//       // Store the full path to redirect the user to after login
//     });
//   }
//   next();
// });



// ... 

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {


  const isPublic = to.matched.some((record) => record.meta.public);
  const loggedIn = !!TokenService.getToken();
  const loggedInApp = !!TokenServiceApp.getToken();

  if (!isPublic && !loggedIn && !loggedInApp) {
    return next({
      path: "/p/login",
      // Store the full path to redirect the user to after login
    });
  }



  
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }


  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

// ...









export default router;
